import { toast } from "react-toastify";
import { fetchData, fetchRequest } from "../../utils/http";
import { fullAPIURL } from "../../utils/requests";
import { getAccessToken } from "../../utils/tokens";

export const fetchApps = async (isDeleted = false) => {
  const token = getAccessToken();
  const request = {
    path: `${fullAPIURL}/v2/appstore/app?isDeleted=${isDeleted}`,
    options: {
      token,
      headers: { "Content-Type": "application/json" },
    },
  };
  const apps = await fetchData(request, true);
  return apps;
};

export const fetchClientSettings = async (clientId, appNames = []) => {
  const token = getAccessToken();
  let url = `${fullAPIURL}/v2/client/client/${clientId}/setting`;

  if (appNames.length > 0) {
    let whereIn = "";

    for (let i = 0; i < appNames.length; ++i) {
      const nam = appNames[i];
      if (i === 0) {
        whereIn = `${whereIn}${nam}`;
      } else {
        whereIn = `${whereIn}%2C${nam}`;
      }
    }

    url = `${url}?type=in:${whereIn}`;
  }

  const request = {
    path: url,
    options: {
      token,
      headers: { "Content-Type": "application/json" },
    },
  };

  const settings = await fetchData(request, true);
  return settings;
};

export const fetchAppDetails = async (id) => {
  const token = getAccessToken();
  const request = {
    path: `${fullAPIURL}/v2/appstore/app/${id}`,
    options: {
      token,
      headers: { "Content-Type": "application/json" },
    },
  };
  const apps = await fetchData(request, true);
  return apps;
};

export const fetchInstalledApps = async (clientId) => {
  const token = getAccessToken();
  const request = {
    path: `${fullAPIURL}/v2/appstore/${clientId}/install`,
    options: {
      token,
      headers: { "Content-Type": "application/json" },
    },
  };
  const apps = await fetchData(request, true);
  return apps;
};

export const installApp = (clientId, appId, callback) => {
  callback = callback || (() => {});
  const token = getAccessToken();
  return fetchRequest({
    method: "POST",
    path: `${fullAPIURL}/v2/appstore/${clientId}/install`,
    body: {
      appId,
    },
    options: {
      token,
      headers: { "Content-Type": "application/json" },
    },
  })
    .then(async (res) => {
      if (!res.ok) {
        const data = await res.json();
        toast.error(data.message, {
          position: "bottom-center",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          progress: undefined,
        });
        throw new Error("Not 2xx response");
      }
      callback();
    })
    .catch((err) => {
      console.error(`There was a error ${err}`);
    });
};

export const uninstallApp = (clientId, installId, callback) => {
  callback = callback || (() => {});
  const token = getAccessToken();
  return fetchRequest({
    method: "DELETE",
    path: `${fullAPIURL}/v2/appstore/${clientId}/install/${installId}`,
    body: {
      installId,
    },
    options: {
      token,
      headers: { "Content-Type": "application/json" },
    },
  })
    .then(async (res) => {
      if (!res.ok) {
        const data = await res.json();
        toast.error(data.message, {
          position: "bottom-center",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          progress: undefined,
        });
        throw new Error("Not 2xx response");
      }
      callback();
    })
    .catch((err) => {
      console.error(`There was a error ${err}`);
    });
};
